"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const FormalReviewClient_1 = require("client/FormalReviewClient");
const ToastContext_1 = require("context/ToastContext");
const useS3Upload_1 = __importDefault(require("hooks/useS3Upload"));
const useValidateCSV_1 = __importDefault(require("hooks/useValidateCSV"));
const CsvHelper_1 = require("utils/CsvHelper");
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const UploadCsv_1 = __importDefault(require("components/teams/modal/ModalImportTeam/UploadCsv"));
const helperClient_1 = require("src/client/helperClient");
const REVIEWEE_NIP = 'Reviewee NIP (required)';
const REVIEWEE_NAME = 'Reviewee Name (required)';
const MANAGER_NIP = 'New Reviewer 1 NIP (optional)';
const MANAGER_NAME = 'New Reviewer 1 Name (optional)';
const INDIRECT_NIP = 'New Reviewer 2 NIP (optional)';
const INDIRECT_NAME = 'New Reviewer 2 Name (optional)';
const listHeader = [
    {
        name: REVIEWEE_NIP,
        type: 'number',
        required: true,
        requiredLength: 8
    },
    {
        name: REVIEWEE_NAME,
        type: 'text',
        required: true,
        length: 255
    },
    {
        name: MANAGER_NIP,
        type: 'number',
        requiredLength: 8,
        dependantName: MANAGER_NAME
    },
    {
        name: MANAGER_NAME,
        type: 'text',
        length: 255,
        dependantName: MANAGER_NIP
    },
    {
        name: INDIRECT_NIP,
        type: 'number',
        requiredLength: 8,
        dependantName: INDIRECT_NAME
    },
    {
        name: INDIRECT_NAME,
        type: 'text',
        length: 255,
        dependantName: INDIRECT_NIP
    }
];
const ModalChangeReviewer = ({ cycleId, setShowModalChangeReviewer }) => {
    const [selectedFile, setSelectedFile] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const history = (0, react_router_1.useHistory)();
    const { uploadFile } = (0, useS3Upload_1.default)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { fileErrorMessage, setFileErrorMessage, validateCSV } = (0, useValidateCSV_1.default)();
    const chooseFile = (e) => {
        const file = e.target.files?.[0];
        e.target.value = '';
        setFileErrorMessage(null);
        if (file) {
            if (file.type === 'text/csv' ||
                file.type === 'application/vnd.ms-excel') {
                setSelectedFile(file);
            }
            else {
                setFileErrorMessage('Please upload a file with .csv extension.');
                setSelectedFile(file);
            }
        }
    };
    const _uploadFile = async (file) => {
        const filename = file.name;
        const extensions = filename.split('.').pop();
        const presignQuery = {
            directory: 'files',
            extension: extensions,
            public: true
        };
        await uploadFile({
            file: file,
            presignQuery,
            onSuccess: async (presignUrl) => {
                await (0, FormalReviewClient_1.importRevieweeSelections)(cycleId, {
                    file: presignUrl.downloadUrl
                });
            },
            onError: () => {
                addToast({
                    msg: (0, HelperUtils_1.getObjectiveLocale)('Something went wrong. Please try again'),
                    type: 'error'
                });
            }
        });
    };
    const handleUploadCSV = async () => {
        setIsLoading(true);
        const file = selectedFile;
        const { flag } = await validateCSV(listHeader, file, {
            delimiter: '',
            skipEmptyLines: true
        });
        if (flag) {
            (0, helperClient_1.progressClientMiddleware)({
                queryFn: () => _uploadFile(selectedFile),
                socketCallback: async (data, listener) => {
                    if (data.type == 'import_reviewee_update_candidate') {
                        if (data?.object?.status == 200) {
                            listener.unregister();
                            setIsLoading(false);
                            history.push(`/reviews/cycles/${cycleId}/change-reviewer`);
                        }
                        else if (data.errors) {
                            addToast({
                                msg: (0, HelperUtils_1.getObjectiveLocale)('Something went wrong. Please try again'),
                                type: 'error'
                            });
                        }
                    }
                }
            });
        }
        else {
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(Modal_1.default, { onClose: () => setShowModalChangeReviewer(false), maxWidthClass: "w-[600px]" },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)('Change Reviewer'), onClose: () => setShowModalChangeReviewer(false) }),
        react_1.default.createElement(Modal_1.default.Body, { customClass: "px-[24px]" },
            react_1.default.createElement(UploadCsv_1.default, { chooseFile: chooseFile, selectedFile: selectedFile, fileErrorMessage: fileErrorMessage, removeFile: () => {
                    setSelectedFile(null);
                    setFileErrorMessage(null);
                }, caption: (0, HelperUtils_1.getObjectiveLocale)('You can manage reviewees whose reviewers will change in bulk by downloading the CSV template and uploading it in this modal section'), disabled: false })),
        react_1.default.createElement(Modal_1.default.Footer, { primaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Import'),
                onClick: () => {
                    handleUploadCSV();
                },
                disabled: selectedFile == null || !!fileErrorMessage || isLoading,
                isLoading: isLoading,
                dataCy: 'import'
            }, secondaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Back'),
                onClick: () => {
                    setShowModalChangeReviewer(false);
                },
                dataCy: 'back'
            }, tertiaryButton: {
                text: (0, HelperUtils_1.getObjectiveLocale)('Download CSV Template'),
                onClick: () => {
                    (0, CsvHelper_1.downloadExportCSV)('/template/CSV-Change-Reviewer-Template.csv');
                },
                dataCy: 'download-csv'
            }, useBorder: false })));
};
exports.default = ModalChangeReviewer;
